import { createAction } from 'redux-actions'

const ROUTE_TO_HOME = 'ROUTE_TO_HOME'
const ROUTE_TO_ONDEMAND = 'ROUTE_TO_ONDEMAND'
const ROUTE_TO_INSTALLED_AGENT = 'ROUTE_TO_INSTALLED_AGENT'
const ROUTE_TO_CLASSROOM_AGENT = 'ROUTE_TO_CLASSROOM_AGENT'
const ROUTE_TO_CLASSROOM_AGENT_RESET = 'ROUTE_TO_CLASSROOM_AGENT_RESET'
const ROUTE_TO_DISCONNECT = 'ROUTE_TO_DISCONNECT'

export const ROUTES = {
  ROUTE_TO_HOME,
  ROUTE_TO_ONDEMAND,
  ROUTE_TO_INSTALLED_AGENT,
  ROUTE_TO_CLASSROOM_AGENT,
  ROUTE_TO_DISCONNECT,
}

export const routeToHome = createAction(ROUTE_TO_HOME)
export const routeToOnDemand = createAction(ROUTE_TO_ONDEMAND)
export const routeToInstalledAgent = createAction(ROUTE_TO_INSTALLED_AGENT)
export const routeToClassroomAgent = createAction(ROUTE_TO_CLASSROOM_AGENT)
export const routeToClassroomAgentReset = createAction(ROUTE_TO_CLASSROOM_AGENT_RESET)
export const routeToDisconnect = createAction(ROUTE_TO_DISCONNECT)
